.placeholder {
  min-height: 250px; /** Guesstimated to be the smallest possible size */
  background: var(--skeleton-background);
  animation-name: glow;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
}
